// NotificationShow.js
import React, { useState, useEffect } from "react";
import axios from "axios";
import { Link, useNavigate } from "react-router-dom";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import Paper from "@mui/material/Paper";
import Button from "@mui/material/Button";
import VisibilityIcon from "@mui/icons-material/Visibility";

export const NotificationShow = () => {
  const [notifications, setNotifications] = useState([]);
  const navigate = useNavigate();
  useEffect(() => {
    async function getInfo() {
      try {
        const { data } = await axios.get(
          `${process.env.REACT_APP_BACKEND_URL}/verify`,
          {
            withCredentials: true,
            headers: {
              "Content-Type": "application/x-www-form-urlencoded",
            },
          }
        );
        if (data.message === "Please login first") {
          navigate("/adminLogin");
        }
      } catch (error) {
        console.log(error);
      }
    }
    getInfo();
  }, []);
  const getAllNotifications = async () => {
    try {
      const { data } = await axios.get(
        `${process.env.REACT_APP_BACKEND_URL}/blogs/notification/`,
        {
          withCredentials: true,
          headers: {
            "Content-Type": "application/x-www-form-urlencoded",
          },
        }
      );
      setNotifications(data);
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    getAllNotifications();
  }, []);

  return (
    <div>
      <div
        style={{ fontSize: "2rem", fontWeight: "500", marginBottom: "1rem" }}
      >
        Notifications:
      </div>
      <TableContainer component={Paper}>
        <Table>
          <TableHead style={{ backgroundColor: "gainsboro" }}>
            <TableRow>
              <TableCell>Notification ID</TableCell>
              <TableCell>Parent Name</TableCell>
              <TableCell>User Name</TableCell>
              <TableCell>Blog ID</TableCell>
              <TableCell>Type</TableCell>
              <TableCell>Status</TableCell>
              <TableCell>Created At</TableCell>
              <TableCell>Action</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {notifications.map((notification) => (
              <TableRow key={notification && notification._id}>
                <TableCell>{notification && notification._id}</TableCell>
                <TableCell>
                  {notification && notification.parent_id.name}
                </TableCell>
                <TableCell>
                  {notification &&
                    notification.user_id &&
                    notification.user_id.name}
                </TableCell>
                <TableCell>{notification && notification.blog_id}</TableCell>
                <TableCell>{notification && notification.type}</TableCell>
                <TableCell>{notification && notification.status}</TableCell>
                <TableCell>
                  {notification &&
                    new Date(notification.createdAt).toLocaleString()}
                </TableCell>
                <TableCell>
                  <Button
                    component={Link}
                    to={`/notifications/${notification && notification._id}`}
                    variant="contained"
                    color="primary"
                  >
                    <VisibilityIcon />
                  </Button>
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
    </div>
  );
};
